// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__39MSr","savePackageButton":"ClientWallet_savePackageButton__1ptU6"};